/** A shortcut, key by key: `<Kbd keys={[MOD, 'K']} />`. */
export function Kbd({ keys }: { keys: string[] }) {
  return (
    <span className="kbd">
      {keys.map((k) => (
        <kbd key={k}>{k}</kbd>
      ))}
    </span>
  );
}
